import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { LocoApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class LocoApiModule {
    public static forRoot(configurationFactory: () => LocoApiConfiguration): ModuleWithProviders<LocoApiModule> {
        return {
            ngModule: LocoApiModule,
            providers: [ { provide: LocoApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: LocoApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('LocoApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
